// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BclkDhZPax_wYFv8SFKQ {
  margin-top: 22px;
}

/* Matches \`.lineageLabel\` in DatasetDetailPanel.module.css - a peer section
   title in the same list of rows. */
.eatowYFjsN9t4JVbEM5l {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1e1f23;
}

.W0ve4EL6gRheQOlyvq8g {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Rows, matching the hairline-separated lineage rows in the detail panel
   rather than adding another stack of bordered cards. */
.KDuxe5jG6cwGZ2LaKhMV {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-height: 40px;
  justify-content: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.aInTyiPQBkk1knnZRKVB {
  font-size: 12px;
  font-weight: 600;
  color: #3b6fd4;
  text-decoration: none;
  word-break: break-all;
}

.aInTyiPQBkk1knnZRKVB:hover {
  text-decoration: underline;
}

/* Shown only when two projects share a name, to tell the rows apart. */
.M_ULkl8M275avXnkRsYw {
  margin-left: 6px;
  font-family: var(--curio-font-mono, ui-monospace, monospace);
  font-size: 11px;
  color: var(--curio-text-secondary);
}

.gEannd9rIKxl664049NP {
  font-size: 11px;
  color: #777;
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetDataflowUsage.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;oCACoC;AACpC;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;wDACwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,4DAA4D;EAC5D,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".section {\n  margin-top: 22px;\n}\n\n/* Matches `.lineageLabel` in DatasetDetailPanel.module.css - a peer section\n   title in the same list of rows. */\n.label {\n  margin: 0 0 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #1e1f23;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Rows, matching the hairline-separated lineage rows in the detail panel\n   rather than adding another stack of bordered cards. */\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-height: 40px;\n  justify-content: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.link {\n  font-size: 12px;\n  font-weight: 600;\n  color: #3b6fd4;\n  text-decoration: none;\n  word-break: break-all;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n/* Shown only when two projects share a name, to tell the rows apart. */\n.disambiguator {\n  margin-left: 6px;\n  font-family: var(--curio-font-mono, ui-monospace, monospace);\n  font-size: 11px;\n  color: var(--curio-text-secondary);\n}\n\n.consumers {\n  font-size: 11px;\n  color: #777;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `BclkDhZPax_wYFv8SFKQ`,
	"label": `eatowYFjsN9t4JVbEM5l`,
	"list": `W0ve4EL6gRheQOlyvq8g`,
	"item": `KDuxe5jG6cwGZ2LaKhMV`,
	"link": `aInTyiPQBkk1knnZRKVB`,
	"disambiguator": `M_ULkl8M275avXnkRsYw`,
	"consumers": `gEannd9rIKxl664049NP`
};
export default ___CSS_LOADER_EXPORT___;
